module.exports = __webpack_public_path__ + "img/contact.589786c4.png";